import React, { useState, useMemo } from 'react'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { Form, Button, Icon } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import InputMask from 'react-input-mask'
import { useSubscription } from 'utils'

export default function RelatoriosForm({ empresas, setRegistros, form, dispatch }) {

    const [isSubmitting, setIsSubmitting] = useState(false)
    const submitForm$ = useMemo(() => request({ 
        url: '/ricms/relatorios', 
        method: "POST", 
        body: form 
    }).pipe(
        tap(({ response }) => setRegistros(response.report)),
        finalize(() => setIsSubmitting(false))
    ), [form, setRegistros])

    function handleChange(event, props) {
        let name, value
        if (!props)
           [name, value] = [event.target.name, event.target.value]
        else {
            name = props.name
            value = props.value
        }
        dispatch({ type: 'setForm', payload: { [name]: value } })
    }

    function handleSubmit() {
        if (!(!!form.empresa) || !(!!form.dataIni) || !(!!form.dataFim))
            toast.error('Há campos não preenchidos.')
        else
            setIsSubmitting(true)        
    }

    useSubscription(submitForm$, isSubmitting)

    return (
        <Form size='mini' className='' onSubmit={handleSubmit} loading={isSubmitting} noValidate>
            <div className="row">
                <div className="col">
                    <Form.Select search noResultsMessage='Nenhum resultado encontrado' required label='Empresa' placeholder='Selecionar empresa' name='empresa' value={form.empresa} onChange={handleChange} options={empresas ? empresas.filter(x => x.ativo === 1 && x.tipo === 'POSTO').map(x => Object.assign({}, { text: x.codDpnet + ' - ' + x.nomeEmpresa, value: x._id })) : []}/>
                </div>
            </div>
            <div className="row pt-3">
                <div className="col">
                    <InputMask mask='99/99/9999' name='dataIni' value={form.dataIni} onChange={handleChange} >
                        {inputProps => <Form.Input {...inputProps} required label='Data Inicial'  placeholder='Informar data inicial' />}
                    </InputMask>                    
                </div>
                <div className="col">
                    <InputMask mask='99/99/9999' name='dataFim' value={form.dataFim} onChange={handleChange} >
                        {inputProps => <Form.Input {...inputProps} required label='Data Final' placeholder='Informar data final' />}
                    </InputMask>
                </div>
            </div>
            <div className="row pt-4 text-center">
                <div className="col">
                    <Button color='green' size='tiny'>
                        <Icon name='search' /> {isSubmitting ? 'Carregando...' : 'Buscar'}
                    </Button>
                </div>
            </div>
        </Form>
    )
}
